/**
 * Branded App section shell.
 *
 * Organization-only: the sidebar entry is hidden in system mode, and a direct
 * URL lands back on the dashboard rather than rendering an empty page.
 * Currently one tab; `PageContent` takes more without restructuring.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import PageContainer from '../../components/Redesing/page-container';
import PageContent from '../../components/Redesing/page-content';
import useOrganization from '../../hooks/use-organization';
import { changeTab } from '../../utils';
import MerchantStoreIndex from './merchantStoreIndex';

const DEFAULT_TAB = 'merchant-locations';

const BrandedAppIndex = () => {
  const organizationInfo = useOrganization();
  const { currentTab = DEFAULT_TAB } = useParams<{ currentTab: string }>();
  const [currentTabV, setCurrentTabV] = useState(currentTab);

  useEffect(() => {
    if (currentTab !== currentTabV) setCurrentTabV(currentTab);
  }, [currentTab, currentTabV]);

  const handleTabsChange = useCallback(
    (_event: React.SyntheticEvent, value: string) => {
      changeTab(value, currentTab, 'branded-app');
    },
    [currentTab]
  );

  if (!organizationInfo?.id) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <PageContainer spaceName="Branded App">
      <PageContent
        dataId="branded-app"
        detailedView={false}
        tabsList={[{ label: 'Merchant Locations', value: DEFAULT_TAB }]}
        tabsChildren={<>{currentTabV === DEFAULT_TAB && <MerchantStoreIndex />}</>}
        currentTabV={currentTabV}
        handleTabsChange={handleTabsChange}
      />
    </PageContainer>
  );
};

export default BrandedAppIndex;
